import React, { useState, useEffect } from 'react'
import { supabase } from '../utils/supabaseClient'

const KATEGORIJOS = [
  { id: 'klaida', tekstas: 'Pranešti klaidą', placeholder: 'Kas neveikia ar atrodo negerai?' },
  { id: 'vieta', tekstas: 'Pasiūlyti vietą', placeholder: 'Papasakok apie vietą — kuo ji ypatinga?' },
  { id: 'idėja', tekstas: 'Idėja', placeholder: 'Ką galėtume pridėti ar pagerinti?' },
  { id: 'kita', tekstas: 'Kita', placeholder: 'Rašyk ką nori — mielai išklausysim.' },
]

function AtsiliepimasEkranas({ atidaryta, onClose, onIssiusta }) {
  const [tipas, setTipas] = useState('klaida')
  const [tekstas, setTekstas] = useState('')
  const [kontaktas, setKontaktas] = useState('')
  const [vietaInfo, setVietaInfo] = useState('')
  const [siunciama, setSiunciama] = useState(false)
  const [klaida, setKlaida] = useState(null)

  useEffect(() => {
    if (atidaryta) {
      setTipas('klaida'); setTekstas(''); setKontaktas(''); setVietaInfo(''); setKlaida(null); setSiunciama(false)
    }
  }, [atidaryta])

  const aktyvi = KATEGORIJOS.find(k => k.id === tipas)

  async function issiusti() {
    if (!tekstas.trim()) { setKlaida('Parašyk bent kelis žodžius.'); return }
    setSiunciama(true); setKlaida(null)
    const { error } = await supabase.from('atsiliepimai').insert({
      tipas,
      tekstas: tekstas.trim(),
      kontaktas: kontaktas.trim() || null,
      vieta_info: tipas === 'vieta' ? (vietaInfo.trim() || null) : null,
    })
    setSiunciama(false)
    if (error) {
      setKlaida('Nepavyko išsiųsti. Bandyk vėliau.')
      return
    }
    onIssiusta('Ačiū! Gavome tavo žinutę')
    onClose()
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1002, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 380ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>

      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '18px 20px 14px', borderBottom: '1px solid #2A3B32' }}>
        <button onClick={onClose} aria-label="Atgal" style={{ width: '36px', height: '36px', borderRadius: '50%', background: 'transparent', border: '1px solid #3A4C42', color: '#F0E8D5', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <h1 style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: '22px', fontWeight: 500, margin: 0 }}>Padėk tobulinti</h1>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '18px 18px 28px' }}>
        <p style={{ color: '#B0B8A8', fontSize: '13px', lineHeight: 1.5, margin: '0 0 16px' }}>
          Tavo pastebėjimai padeda kurti geresnę Lietuvos kelionių programėlę.
        </p>

        {/* Kategorijos */}
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '18px' }}>
          {KATEGORIJOS.map(k => (
            <button
              key={k.id}
              onClick={() => setTipas(k.id)}
              style={{ padding: '7px 12px', borderRadius: '8px', border: `1px solid ${tipas === k.id ? 'rgba(229,168,64,0.4)' : '#2A3B32'}`, color: tipas === k.id ? '#E5A840' : '#B0B8A8', fontSize: '12px', background: tipas === k.id ? 'rgba(229,168,64,0.14)' : 'transparent', cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif' }}
            >
              {k.tekstas}
            </button>
          ))}
        </div>

        {/* Vietos laukas (tik „Pasiūlyti vietą") */}
        {tipas === 'vieta' && (
          <input
            value={vietaInfo}
            onChange={e => setVietaInfo(e.target.value)}
            placeholder="Vietos pavadinimas ir miestas"
            style={{ width: '100%', boxSizing: 'border-box', height: '46px', padding: '0 14px', background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: '10px', color: '#F0E8D5', fontSize: '14px', fontFamily: 'Syne, system-ui, sans-serif', marginBottom: '12px', outline: 'none' }}
          />
        )}

        {/* Tekstas */}
        <textarea
          value={tekstas}
          onChange={e => setTekstas(e.target.value)}
          placeholder={aktyvi.placeholder}
          rows={5}
          style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: '10px', color: '#F0E8D5', fontSize: '14px', fontFamily: 'Syne, system-ui, sans-serif', resize: 'vertical', outline: 'none', marginBottom: '12px' }}
        />

        {/* Kontaktas */}
        <input
          value={kontaktas}
          onChange={e => setKontaktas(e.target.value)}
          placeholder="El. paštas (jei nori atsakymo)"
          style={{ width: '100%', boxSizing: 'border-box', height: '46px', padding: '0 14px', background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: '10px', color: '#F0E8D5', fontSize: '14px', fontFamily: 'Syne, system-ui, sans-serif', marginBottom: '18px', outline: 'none' }}
        />

        {klaida && <p style={{ color: '#C86353', fontSize: '13px', margin: '0 0 12px' }}>{klaida}</p>}

        <button
          onClick={issiusti}
          disabled={siunciama}
          style={{ width: '100%', height: '52px', borderRadius: '12px', background: '#E5A840', color: '#141F1A', border: 'none', fontFamily: "'Lora', Georgia, serif", fontSize: '16px', fontWeight: 600, cursor: siunciama ? 'default' : 'pointer', opacity: siunciama ? 0.6 : 1 }}
        >
          {siunciama ? 'Siunčiama…' : 'Siųsti'}
        </button>
      </div>
    </div>
  )
}

export default AtsiliepimasEkranas
